import React from "react"
import ScreenLayout from "./ScreenLayout"
import { LegacyScreenHost, useRoute } from "./navigation"
import useNavigation from "~hooks/useNavigation"
import { resolveScreenOptions, resolveScreenTitle, type AppScreenOptions } from "./screen-options"

export function ConfiguredLegacyScreen({
  name,
  component,
  options,
}: {
  name: string
  component: React.ComponentType<{ route?: ReturnType<typeof useRoute>; navigation?: ReturnType<typeof useNavigation> }>
  options?: AppScreenOptions
}) {
  const route = useRoute()
  const navigation = useNavigation()
  const ctx = { navigation, route: { params: route.params as Record<string, unknown> | undefined } }
  const resolved = resolveScreenOptions(options, ctx)
  const title = resolveScreenTitle(name, options, ctx)
  const headerShown = resolved.headerShown !== false

  return (
    <ScreenLayout
      title={title}
      headerShown={headerShown}
      headerBackVisible={resolved.headerBackVisible}
      configHeaderRight={resolved.headerRight}
    >
      <LegacyScreenHost component={component} />
    </ScreenLayout>
  )
}
